/**
 * ClosedCardRow — public entry point for one closed card inside the Closed area
 * (SE-6862). Exposes the Container, which owns the overflow-menu state and the
 * Player Card v7 adapter.
 *
 * Nested under the ClosedArea organism rather than promoted to its own molecule
 * directory: it has exactly one consumer and no meaning outside the Closed
 * panel, which is the same reason KanbanColumnSkeleton sits inside
 * KanbanColumn.
 * @module features/player-kanban/components/organisms/ClosedArea/ClosedCardRow
 */

export { default } from "./ClosedCardRowContainer";
export type { ClosedCardRowContainerProps } from "./ClosedCardRowContainer";
